import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-advanced-alert-type-badge',
  templateUrl: './advanced-alert-type-badge.component.html',
  styleUrls: ['./advanced-alert-type-badge.component.scss']
})
export class AdvancedAlertTypeBadgeComponent implements OnInit {
  @Input('type') public readonly type: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
